class DeliveryEstimate extends HTMLElement {
  connectedCallback() {
    const now = new Date();
    const cutoff = Number(this.dataset.cutoff);
    const skipWeekends = this.dataset.skipWeekends === 'true';
    const min = Number(this.dataset.min);
    const max = Number(this.dataset.max);
    const locale = this.dataset.locale || 'en';

    let start = new Date(now);
    const afterCutoff = now.getHours() >= cutoff;
    if (afterCutoff) start.setDate(start.getDate() + 1);
    if (skipWeekends) while ([0, 6].includes(start.getDay())) start.setDate(start.getDate() + 1);

    const addDays = (date, days) => {
      const d = new Date(date);
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (!skipWeekends || ![0, 6].includes(d.getDay())) added += 1;
      }
      return d;
    };
    const from = addDays(start, min);
    const to = addDays(start, max);
    const fmt = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'short' });
    const range = this.querySelector('[data-delivery-range]');
    if (range) range.textContent = min === max ? fmt.format(from) : `${fmt.format(from)} – ${fmt.format(to)}`;

    const cutoffEl = this.querySelector('[data-delivery-cutoff]');
    if (cutoffEl && !afterCutoff && ![0, 6].includes(now.getDay())) {
      const hours = Math.max(1, Math.ceil((cutoff * 60 - (now.getHours() * 60 + now.getMinutes())) / 60));
      const hoursEl = cutoffEl.querySelector('[data-hours]');
      if (hoursEl) hoursEl.textContent = String(hours);
      cutoffEl.hidden = false;
    }
  }
}
if (!customElements.get('delivery-estimate')) customElements.define('delivery-estimate', DeliveryEstimate);
